import { render, staticRenderFns } from "./approverRegistrationModal.vue?vue&type=template&id=0db6c832&scoped=true&"
import script from "./approverRegistrationModal.vue?vue&type=script&lang=js&"
export * from "./approverRegistrationModal.vue?vue&type=script&lang=js&"
import style0 from "./approverRegistrationModal.vue?vue&type=style&index=0&id=0db6c832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db6c832",
  null
  
)

export default component.exports